(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    /*
   * Keep a card's photograph and price on the variant its picker is showing.
   *
   * Delegated from the document rather than bound per card: the grid is
   * rendered server-side and a card can arrive later through a section
   * re-render, at which point per-element listeners would be missing.
   */
  document.addEventListener('change', (event) => {
    const select = event.target.closest('.product-card__select');
    if (!select) return;

    const card = select.closest('.product-card');
    const option = select.selectedOptions[0];
    if (!card || !option) return;

    const price = card.querySelector('[data-card-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;

    const image = card.querySelector('.product-card__image');
    if (!image) return;

    /*
     * The markup's own src is the fallback for variants that carry no
     * photograph of their own, captured on first use rather than printed
     * into a data attribute on every card that will never need it.
     */
    if (image.dataset.baseSrc === undefined) {
      image.dataset.baseSrc = image.getAttribute('src') || '';
      image.dataset.baseSrcset = image.getAttribute('srcset') || '';
    }

    const src = option.dataset.image || image.dataset.baseSrc;
    const srcset = option.dataset.srcset || image.dataset.baseSrcset;
    if (!src || image.getAttribute('src') === src) return;

    /*
     * Faded out before the swap and back in once the replacement is ready,
     * so the card never shows a half-painted image.
     *
     * The class sets opacity: 0, so whatever restores it must be
     * guaranteed to run — decode() alone is not. In a backgrounded tab it
     * stays pending indefinitely even for an image that has fully loaded
     * (observed: complete === true, naturalWidth set, promise still
     * pending after two seconds), which would leave the photograph
     * permanently invisible. Whichever signal arrives first wins, and the
     * timer means one always does.
     */
    image.classList.add('is-swapping');
    image.setAttribute('src', src);
    if (srcset) {
      image.setAttribute('srcset', srcset);
    } else {
      image.removeAttribute('srcset');
    }

    let settled = false;
    let timer;
    const settle = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      image.classList.remove('is-swapping');
    };

    timer = setTimeout(settle, 400);
    image.addEventListener('load', settle, { once: true });
    image.addEventListener('error', settle, { once: true });
    if (typeof image.decode === 'function') image.decode().then(settle, settle);
  });
  } catch(e) { console.error(e); }
})();

})();
